/**
 * FarmersInventory — Farmers Pulse view of the Universal Inventory app.
 *
 * A thin brand wrapper around the generic InventoryApp component so the
 * same inventory system can be embedded on any SocialPulse-family site
 * (NaturePulse, PhotoPulse, TravelerPulse, …) via its own wrapper.
 *
 * Route: /farmers/inventory (embedded) or /inventory (standalone fork).
 */
import InventoryApp from "@/pages/InventoryApp";
import FarmersNav from "@/components/FarmersNav";
import { fpPath } from "@/lib/site";

export default function FarmersInventory() {
  return (
    <InventoryApp
      context="farmers"
      brand="Farmers Pulse"
      accent="#B85F2A"
      backLabel="My Farm"
      backHref={fpPath("/mine")}
      navSlot={<FarmersNav />}
      sellTargetLabel="List on shop"
      apiPrefix="/farmers/inventory"
    />
  );
}
